<template>
    <kgr-form-scaffold
        :pending="pending"
        :save-button-disabled="saveButtonDisabled"
        @primaryBtnClicked="addOffering"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-offering-create-form
            v-if="offering"
            :club-id="clubId"
            :offering-prop="offering"
            :error="error"
            :sales-list-module-enabled="salesListModuleEnabled"
            :can-edit-sales-list-offering-items="canEditSalesListOfferingItems"
            @enter="addOffering"
            @appointmentInvalid="saveButtonDisabled = $event"
            @offeringItemsSelected="addOfferingItems($event)"
        />
    </kgr-form-scaffold>
</template>

<script>
import CourseOfferingRepository from '../../js/repository/club/offering/CourseOfferingRepository';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrOfferingCreateForm from '../../components/offering/OfferingCourseCreateForm';
import Offering from '../../js/dto/offering/Offering';
import OfferingValidator from '../../js/offering/OfferingValidator'

export default {
    components: {
        'kgr-offering-create-form': KgrOfferingCreateForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        salesListModuleEnabled: {
            type: Boolean,
            required: true,
        },
        canEditSalesListOfferingItems: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            offering: null,
            error: new Error(),
            saveButtonDisabled: false,
        };
    },
    computed: {
        referenceId() {
            return new URL(location.href).searchParams.get('ref');
        },
    },
    created() {
        if (this.referenceId !== null && this.referenceId.length > 0) {
            CourseOfferingRepository.find(this.referenceId)
                .then(reference => this.offering = Offering.duplicate(reference))
                .catch(() => this.$notify.error('error.loadingData'));
        } else {
            this.offering = new Offering();
        }
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        addOffering() {
            this.error = OfferingValidator.validateCourseOffering(this.offering);
            if (!this.error.isEmpty()) {
                return this.$notify.error('offering.flash.errorAddingOffering');
            }

            this.pending = true;
            CourseOfferingRepository.create(this.offering, this.clubId)
                .then(redirectUrl => {
                    this.$notify.success('offering.flash.addedCourse', {}, { saveInSession: true });
                    window.location = redirectUrl;
                })
                .catch(error => {
                    this.error = error;
                    this.$notify.error('offering.flash.errorAddingCourse');
                    this.pending = false;
                });
        },
        addOfferingItems(offeringItems) {
            this.offering.salesListOfferingItems = offeringItems;
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
